import { identityBiometricService, identityBiometricCheckService, identitiesStatusService } from '@afterpaytouch/portal-api/consumer/identityBiometric'

export const { useCreateApplicantsMutation, useCreateInquiryIdMutation } = identityBiometricService

export const { useCheckBiometricStatusQuery } = identityBiometricCheckService

export const { useCheckIdentitiesQuery } = identitiesStatusService
